import * as React from 'react';
import Checkbox, { CheckboxChangeEvent } from 'antd/lib/checkbox';
import Flex from 'antd/lib/flex';
import FormItem from 'antd/lib/form/FormItem';
import TooltipInfoIcon from '../helperComponents/TooltipInfoIcon';

export interface MatchPhasedReleaseCheckboxProps {
    visible: boolean;
    defaultChecked?: boolean;
    onChange?: (checked: boolean) => void;
    /** If true, uses FormItem wrapper with valuePropName="checked" */
    useFormItem?: boolean;
}

const TOOLTIP_CONTENT =
    "Runway will start the hotfix staged rollout at the same percentage where the previous release's rollout left off (determined at time of hotfix release), then will increment from there according to the remainder of your configured staged rollout sequence.";

export const MatchPhasedReleaseCheckbox: React.FC<MatchPhasedReleaseCheckboxProps> = ({
    visible,
    defaultChecked = false,
    onChange,
    useFormItem = false,
}) => {
    if (!visible) {
        return null;
    }

    const handleChange = (e: CheckboxChangeEvent) => {
        onChange?.(e.target.checked);
    };

    const checkboxContent = (
        <Flex align="center">
            <Checkbox defaultChecked={defaultChecked} onChange={handleChange}>
                Upon release, start rollout where previous release left off
            </Checkbox>
            <TooltipInfoIcon tooltipContent={TOOLTIP_CONTENT} />
        </Flex>
    );

    if (useFormItem) {
        return (
            <FormItem name="shouldMatchPreviousPhasedRelease" valuePropName="checked">
                {checkboxContent}
            </FormItem>
        );
    }

    return checkboxContent;
};
